import { render } from "./Preregistered.vue?vue&type=template&id=b826ea6c"
import script from "./Preregistered.vue?vue&type=script&lang=js"
export * from "./Preregistered.vue?vue&type=script&lang=js"
script.render = render

export default script